import { cn } from '@/lib/utils';
import { useController, UseControllerProps } from 'react-hook-form';

type ToggleInputProps = {
	label?: string;
	disabled?: boolean;
	className?: string;
} & UseControllerProps<any>;

export const ToggleInput = ({
	label,
	disabled = false,
	className = '',
	...props
}: ToggleInputProps) => {
	const {
		field: { value, onChange, ...field },
	} = useController(props);

	return (
		<div className={cn('flex items-center', className)}>
			{label && (
				<span className="mr-3 text-sm font-medium text-dark dark:text-zinc-300 ">
					{label}
				</span>
			)}
			<label className="relative inline-flex cursor-pointer items-center">
				<input
					type="checkbox"
					className="peer sr-only"
					checked={value}
					onChange={(e) => onChange(e.target.checked)}
					disabled={disabled}
					{...field}
				/>
				<div
					className={`peer h-6 w-11 rounded-full  border bg-gray-200 peer-focus:outline-none  ${
						value
							? 'peer-checked:after:translate-x-full peer-checked:after:border-white'
							: ''
					} after:absolute after:left-[2px] after:top-[2px] after:h-5 after:w-5 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all after:content-['']  peer-checked:bg-cyan-800`}
				/>
			</label>
		</div>
	);
};
